// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"ede23009","409":"2d6bc05d","838":"ddc322b3"}[chunkId] + ".chunk.js";
};